import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, message, Modal } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { DevicesAPI } from 'api/DevicesAPI';
import { useEnsureContext } from 'common/hooks';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import React, { FC } from 'react';
import { useMutation } from 'react-query';

interface GenerateDevicesTokensButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  onGenerate?: () => void;
  subPartnersIds: string;
}

export const GenerateDevicesTokensButton: FC<GenerateDevicesTokensButtonProps> = ({
  onGenerate,
  subPartnersIds,
  ...buttonProps
}) => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const [mutate, { isLoading }] = useMutation(DevicesAPI.generateDevicesTokens);
  const intlMessage = useFormatMessage();

  const showConfirm = () =>
    Modal.confirm({
      title: intlMessage({ id: 'devices.generateTokens.confirm' }),
      icon: <ExclamationCircleOutlined />,
      okText: intlMessage({ id: 'yes' }),
      cancelText: intlMessage({ id: 'cancel' }),
      okType: 'primary',
      onOk: () =>
        mutate(
          {
            businessPartnerId: bpContext.id,
            subPartnersIds: subPartnersIds,
          },
          {
            onSuccess: () => {
              message.success(
                intlMessage({ id: 'devices.generateTokens.success' })
              );
              onGenerate && onGenerate();
            },
          }
        ),
    });

  return (
    <Button
      id="button-generate-devices-tokens"
      type="primary"
      loading={isLoading}
      onClick={showConfirm}
      {...buttonProps}
    />
  );
};
